import React from 'react'
import classNames from 'classnames'
import { TextLinkProps } from '@toasttab/shared/src/components/molecules/TextLink/TextLink.d'
import {
  Arrow,
  Download
} from '@toasttab/shared/src/components/molecules/TextLink/TextLinkIcons/TextLinkIcons'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const TextLink = ({
  allowHtml = false,
  classes,
  color = 'default',
  el = 'a',
  fontSize = ['text-base'],
  fontWeight = ['font-semibold'],
  heading,
  heapInteraction,
  href = '',
  icon,
  iconClass,
  onClick,
  target,
  text,
  unlinkedText,
  underline = false,
  underlineHover = false
}: TextLinkProps) => {
  const Element = el

  const linkTextClasses = classNames(classes, 'font-sansPro leading-[36px]', {
    [fontSize.join(' ')]: fontSize,
    [fontWeight.join(' ')]: fontWeight,
    block: heading,
    'group inline-flex items-center': icon,
    'text-blue-75 text-primary-blue-75 hover:text-blue-100':
      color === 'default',
    'text-white hover:text-gray-30': color === 'light',
    underline: underline,
    'relative w-fit hover:after:content_[""] hover:after:inline-flex hover:after:absolute hover:after:bottom-0 hover:after:w-full hover:after:h-[1px]':
      underlineHover,
    'hover:after:bg-blue-100': underlineHover && color === 'default',
    'hover:after:bg-gray-30': underlineHover && color === 'light'
  })

  const iconClasses = classNames(iconClass, {
    'ml-1 transition-all group-hover:translate-x-[7px]': icon,
    'stroke-blue-75 group-hover:stroke-blue-100':
      (icon === 'arrow' || icon === 'arrowRight') && color === 'default',
    'stroke-white group-hover:stroke-gray-30':
      (icon === 'arrow' || icon === 'arrowRight') && color === 'light',
    'fill-blue-75 group-hover:fill-blue-100':
      icon === 'download' && color === 'default',
    'fill-white group-hover:fill-gray-30':
      icon === 'download' && color === 'light'
  })

  return (
    <>
      {heading && (
        <Typography
          as='p'
          variation='default'
          classes='block text-gray-100 pt-1'
        >
          {heading}
        </Typography>
      )}
      <Element
        href={href}
        onClick={onClick}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        target={target === '_blank' ? '_blank' : undefined}
        className={linkTextClasses}
        data-interaction={heapInteraction ?? ''}
        data-testid='text-link'
      >
        {unlinkedText && (
          <span className='inline-block mr-4 font-normal '>{unlinkedText}</span>
        )}
        {allowHtml ? <span dangerouslySetInnerHTML={{ __html: text }} /> : text}
        {(icon === 'arrow' || icon === 'arrowRight') && (
          <Arrow classes={iconClasses} />
        )}
        {icon === 'download' && <Download classes={iconClasses} />}
      </Element>
    </>
  )
}

export default TextLink
